import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { Stack, Typography } from '@mui/material';
import _ from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import LocalBlacklistsTable from './local-blacklists-table';
import NoLocalBlacklistsFound from './no-local-blacklists-found';
import PaiDotLoader from 'features/ui/base-components/pai-dot-loader';
import { Blacklist_New } from 'features/co-pilot/company-blacklists/company-blacklist.types';

interface Props {
  localBlacklists: Blacklist_New[];
  localBlacklistsLoading: boolean;
  removeBlacklistItemsLoading: boolean;
  selectedLocalBlacklists: string[];
  blacklistSyncLoading: boolean;

  handleSelectedBlacklistsChange(blacklist: Blacklist_New): () => void;

  handleOpenAddLocalBlacklistDialog(): void;

  handleOpenEditBlacklistItemsDialog(blacklist: Blacklist_New): () => void;

  handleOpenEditBlacklistNameDialog(blacklist: Blacklist_New): () => void;

  handleOpenDeleteBlacklistDialog(blacklist: Blacklist_New): () => void;

  handleRemoveSingleBlacklistItem(blacklist: Blacklist_New): (identifier: string) => () => void;
}

const LocalBlacklists: React.FC<Props> = ({
  localBlacklists,
  localBlacklistsLoading,
  removeBlacklistItemsLoading,
  selectedLocalBlacklists,
  blacklistSyncLoading,
  handleSelectedBlacklistsChange,
  handleOpenAddLocalBlacklistDialog,
  handleOpenEditBlacklistItemsDialog,
  handleOpenEditBlacklistNameDialog,
  handleOpenDeleteBlacklistDialog,
  handleRemoveSingleBlacklistItem,
}) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Stack className={classes.localBlacklists} gap={2}>
      {localBlacklistsLoading ? (
        <PaiDotLoader />
      ) : _.isEmpty(localBlacklists) ? (
        <NoLocalBlacklistsFound handleOpenAddLocalBlacklistDialog={handleOpenAddLocalBlacklistDialog} />
      ) : (
        <>
          <Stack direction={'row'} alignItems={'center'} gap={1}>
            <ArrowRightAltIcon className={classes.arrow} />
            <Typography className={classes.boldText}>{t('activateExistingBlacklists')}</Typography>
          </Stack>
          <LocalBlacklistsTable
            blacklists={localBlacklists}
            loading={removeBlacklistItemsLoading}
            selectedLocalBlacklists={selectedLocalBlacklists}
            blacklistSyncLoading={blacklistSyncLoading}
            handleSelectedBlacklistsChange={handleSelectedBlacklistsChange}
            handleOpenAddLocalBlacklistDialog={handleOpenAddLocalBlacklistDialog}
            handleOpenEditBlacklistItemsDialog={handleOpenEditBlacklistItemsDialog}
            handleOpenEditBlacklistNameDialog={handleOpenEditBlacklistNameDialog}
            handleOpenDeleteBlacklistDialog={handleOpenDeleteBlacklistDialog}
            handleRemoveSingleBlacklistItem={handleRemoveSingleBlacklistItem}
          />
        </>
      )}
    </Stack>
  );
};

const useStyles = makeStyles()((theme) => ({
  localBlacklists: {
    height: '100%',
    overflow: 'hidden',
  },
  boldText: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 'bold',
  },
  arrow: {
    fontSize: theme.typography.pxToRem(32),
    color: theme.palette.primary.main,
  },
}));

export default LocalBlacklists;
